import Cookies from 'js-cookie';

import { getSafeQueryParams } from '../url';

export const storeCookieFromSearchParam = (cookieName: string, queryName: string) => {
  const queryParams = getSafeQueryParams();
  const value = queryParams?.[queryName];

  if (typeof value === 'string') {
    Cookies.set(cookieName, value);
  }
};

